import Vue from "vue";
import Vuex from "vuex";

import { auth } from "./auth.module";
import { employee } from "./employee.module";
import { training } from "./training.module";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    employee,
    training,
  },
});
